import React, {Component} from 'react';
import './Home.css';
import clown from './clown.png';
import saveTheChildren from './SaveTheChildren.jpeg';
import redcross from './redcross.png';
import defense from './defense.png';
import giving from './giving.png';
import {checkStatus, returnCount} from './Mint';

class Home extends Component {
    state = {
      count: 1,
    }
 
    increment = () => {
      this.setState((state) => {
        if(state.count < 20) {
          checkStatus(document.getElementsByClassName('mint')[0], Number(document.getElementsByClassName("num")[0].value) + 1);
          return {count: state.count + 1}
        } else {
          return {count: state.count}
        }
      });
    }

    decrement = () => {
      this.setState((state) => {
        if(state.count > 1) {
          checkStatus(document.getElementsByClassName('mint')[0], Number(document.getElementsByClassName("num")[0].value ) - 1);
          return {count: state.count - 1}
        } else {
          return {count: state.count}
        }
      });
    }

    handleChange = (event) => {
      this.setState({state: event.target.value});
    }

    componentDidMount() {
      const mintButton = document.getElementsByClassName('mint')[0];
      const amount = Number(document.getElementsByClassName("num")[0].value);
      const minted = document.getElementsByClassName('minted')[0];
  
      returnCount(minted);
      checkStatus(mintButton, amount);
    }
  
    render() {
      return (
        <div>
        <div className="ninety">
          <div className="homepage">
            <h1 className="title"> Fuck Vladimir Putin. </h1>
            <h2 className="subtitle"> That is all. </h2>
            <div className='mint-body'>
              <div className="description">
                <img className="putin" src={clown}/>
                <h2 className="minted"> 0000/2999</h2>
                <div className="invitation">
                  FuckPutinDAO
                </div>
                <div className="price">
                  0.019 Ξ 
                  <p className="free"> (First 300 free)</p>
                </div>
              </div>
              <div className="amount">
                  <button className="minmax" onClick={this.decrement}> - </button>
                  <input className="num" type="text" value={this.state.count} onChange={this.handleChange} readOnly ></input>
                  <button className="minmax" onClick={this.increment}> + </button>
              </div>
              <button className="mint"> MINT </button>
            </div>
          </div>
        </div>
        <div className="bottom">
          <div className="purpose">
            <h1 className="purpose-title">PURPOSE</h1>
            <p className="pppurpose">The purpose of this DAO is twofold: </p>
            <p className="ppurpose"> 1. To plaster web3 with this image of Putin as a gay clown banned by the Justice Ministry of Russia. </p>
            <p className="ppurpose"> 2. To raise funds for Ukraine. 80% of primary and secondary sales will be split evenly between the charities below. 
            </p>
          </div>
          <div className="charities purpose">
          <a className="clickable-div" href="https://redcross.org.ua/en/2022/02/donate-to-support-the-ukrainian-red-cross-to-help-civilians-in-this-difficult-time-for-ukraine/">
            <div className="card">
              Ukraine Crisis Relief Fund
            </div>
            <div className="pic-container">
              <img className="pix-1" src={giving}/>
            </div>
          </a>
          <a  className="clickable-div"  href="https://ukraine.ua/news/support-the-armed-forces-of-ukraine/">
            <div className="card">
              Ukraine Ministry of Defense
            </div>
            <div className="pic-container">
              <img className="pix" src={defense}/>
            </div>
          </a>
          <a  className="clickable-div"  href="https://thegivingblock.com/donate/save-the-children/">
            <div className="card">
              Save the Children
            </div>
            <div className="pic-container">
              <img className="pix" src={saveTheChildren}/>
            </div>
          </a>
          </div>
          <div  className="purpose">
            Receipts and proof of donations will be posted on this website. 
          </div>
        </div>
        </div>
        );
    }
}

export default Home;